module.exports = "/images/wix.png?0061fb4eecb7f73a817138c6440e40ec";